import { encuestaFormModel } from './encuestaFormModel';

const {
  formField: { name, description, type, areas_rating_id, questions, reviewLinks },
} = encuestaFormModel;

export const formInitialValues = {
  [name.name]: '',
  [description.name]: '',
  [type.name]: null,
  [areas_rating_id.name]: null,
  [questions.name]: [
    {
      questionText: '',
      order: 0,
      isRequired: false,
      isOpenQuestion: false,
      openQuestionType: 'text',
      imgName: null,
      localPreview: '',
      metricType: null,
    },
  ],
  [reviewLinks.name]: [],
};
